<div class="search-container">
  <div class="search-input">
    <ng-content select="[checkboxFilter]"></ng-content>
    <input *ngIf="formControl" [formControl]="formControl" [placeholder]="placeholder" class="search">
    <span class="search-icon" [inlineSVG]="'assets/media/netop/search.svg'" *ngIf="!searchText"></span>
  </div>
  <ng-content select="[nextToSearch]"></ng-content>
</div>
